function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useMemo } from 'react';
import { Layout } from '@leverege/plugin';
import { MenuFactory, useSharedContext } from '@leverege/ui-plugin';
import { Popup } from '@leverege/ui-elements';
import ConditionCreators from "./ConditionCreators.js";
const FACTORY = new MenuFactory();
export default function ConditionSelector(props) {
  const {
    factory = FACTORY,
    eventData,
    onSelect,
    ...rest
  } = props;
  const {
    conditionCreators
  } = useSharedContext();
  const layout = useMemo(() => {
    return Layout.create(ConditionCreators.toActions(conditionCreators || [], onSelect, eventData));
  }, [conditionCreators]);
  const render = useMemo(() => {
    return onClose => {
      return factory.createComponents(layout, {}, onClose);
    };
  }, [layout, factory]);
  return /*#__PURE__*/React.createElement(Popup, _extends({
    variant: "logicConditionSelector|conditionSelector",
    toggleAttributes: {
      variant: 'logicConditionSelector|conditionSelector'
    }
  }, rest, {
    render: render
  }));
}